import React from 'react';

const SKILLS = [
  { name: 'React.js',         pct: 90 },
  { name: 'Node.js / Express', pct: 85 },
  { name: 'MongoDB',           pct: 80 },
  { name: 'TypeScript',        pct: 70 },
];

const TIMELINE = [
  { year: '2017',       text: 'B.Tech IT — Asansol Engineering College' },
  { year: '2017–2023',  text: 'Admin & Operations — Essbee Fire Service' },
  { year: '2023',       text: 'Started self-learning MERN stack development' },
  { year: 'Now',        text: 'Full Stack Developer — Open to opportunities' },
];

// SVG icons (inline, no extra dep)
const IconCode = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
  </svg>
);
const IconProjects = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 6h-2.18c.07-.44.18-.86.18-1.3C18 2.12 15.88 0 13.3 0c-1.3 0-2.48.54-3.3 1.41L9 3 7.99 1.41C7.17.54 6.0 0 4.7 0 2.12 0 0 2.12 0 4.7c0 .44.11.86.18 1.3H0v2h20V6zm-9.99 0l1.4-1.54C11.96 3.84 12.62 3.5 13.3 3.5c.66 0 1.2.54 1.2 1.2 0 .44-.22.85-.6 1.3H10.01zM4.7 3.5c.68 0 1.34.34 1.89.96L8 6H5.1C4.72 5.54 4.5 5.14 4.5 4.7c0-.66.54-1.2 1.2-1.2zM0 9v11c0 1.1.9 2 2 2h8V9H0zm12 13h8c1.1 0 2-.9 2-2V9h-10v13z"/>
  </svg>
);
const IconEdu = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/>
  </svg>
);
const IconRemote = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 6H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10zM6 10h12v2H6zm0 4h8v2H6z"/>
  </svg>
);
const IconSkills = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.5 6c-1.31 0-2.37 1.01-2.48 2.29L12.5 10.5 8.5 8.29C8.37 7.01 7.31 6 6 6c-1.38 0-2.5 1.12-2.5 2.5 0 1.22.88 2.24 2.04 2.45l2.46 6.14C7.43 17.38 7 18.14 7 19c0 1.66 1.34 3 3 3s3-1.34 3-3c0-.87-.43-1.63-1.09-2.1l.62-1.55 3.44 3.44C16 19.43 16 20 16 20.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5c-.17 0-.34.02-.5.06l-3.68-3.68.66-1.65c1.22-.18 2.19-1.19 2.45-2.47C18.55 9.62 19.5 8.31 19.5 6z"/>
  </svg>
);

const About = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=Space+Mono:wght@400;700&display=swap');

        :root {
          --accent:  #00f5d4;
          --accent2: #7b61ff;
          --accent3: #ff4ecd;
          --bg:      #07090f;
          --text:    #e8eaf6;
          --muted:   rgba(232,234,246,0.45);
          --border:  rgba(0,245,212,0.13);
          --card-bg: rgba(255,255,255,0.03);
        }

        /* ── SECTION ── */
        .ab-section {
          position: relative;
          padding: 6rem 2rem;
          background: var(--bg);
          font-family: 'Syne', sans-serif;
          overflow: hidden;
        }

        /* bg radials */
        .ab-section::before {
          content: '';
          position: absolute; inset: 0; z-index: 0;
          background:
            radial-gradient(ellipse 50% 60% at 80% 20%, rgba(123,97,255,0.1) 0%, transparent 70%),
            radial-gradient(ellipse 40% 50% at 10% 80%, rgba(0,245,212,0.07) 0%, transparent 70%);
          pointer-events: none;
        }

        /* scanlines */
        .ab-section::after {
          content: '';
          position: absolute; inset: 0; z-index: 0;
          background: repeating-linear-gradient(
            0deg,
            transparent, transparent 2px,
            rgba(0,245,212,0.015) 2px, rgba(0,245,212,0.015) 4px
          );
          pointer-events: none;
        }

        .ab-inner {
          position: relative; z-index: 1;
          max-width: 1160px; margin: 0 auto;
        }

        /* ── HEADING ── */
        .ab-heading {
          text-align: center;
          margin-bottom: 4rem;
          opacity: 0;
          animation: abFadeUp 0.6s ease 0.1s forwards;
        }
        .ab-tag {
          display: inline-flex; align-items: center; gap: 8px;
          font-family: 'Space Mono', monospace;
          font-size: 0.68rem; letter-spacing: 0.2em;
          text-transform: uppercase; color: var(--accent);
          margin-bottom: 1rem;
        }
        .ab-tag::before, .ab-tag::after {
          content: '';
          display: inline-block; width: 20px; height: 1.5px;
          background: var(--accent); box-shadow: 0 0 8px var(--accent);
        }
        .ab-main-title {
          font-size: clamp(1.8rem, 4vw, 2.8rem);
          font-weight: 800; letter-spacing: -0.03em;
          color: #fff;
        }
        .ab-main-title .ab-accent {
          background: linear-gradient(90deg, var(--accent) 0%, var(--accent2) 60%, var(--accent3) 100%);
          -webkit-background-clip: text; background-clip: text; color: transparent;
          background-size: 200% auto;
          animation: abGrad 4s linear infinite;
        }

        /* ── LAYOUT GRID ── */
        .ab-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: start;
        }

        /* ── LEFT — TEXT ── */
        .ab-left {
          opacity: 0;
          animation: abFadeUp 0.7s ease 0.2s forwards;
        }
        .ab-role {
          font-family: 'Space Mono', monospace;
          font-size: 0.78rem; letter-spacing: 0.1em;
          text-transform: uppercase; color: var(--accent2);
          margin-bottom: 1.5rem;
          display: flex; align-items: center; gap: 10px;
        }
        .ab-role::after {
          content: '';
          flex: 1; height: 1px;
          background: linear-gradient(90deg, rgba(123,97,255,0.4), transparent);
        }

        .ab-text {
          font-size: 0.96rem;
          color: var(--muted); line-height: 1.8;
          margin-bottom: 1rem;
        }
        .ab-text strong { color: var(--text); font-weight: 600; }
        .ab-text:last-of-type { margin-bottom: 0; }

        /* timeline */
        .ab-timeline {
          margin-top: 2rem; padding-top: 2rem;
          border-top: 1px solid var(--border);
          display: flex; flex-direction: column; gap: 14px;
        }
        .ab-tl-item {
          display: flex; align-items: flex-start; gap: 14px;
        }
        .ab-tl-dot-wrap {
          display: flex; flex-direction: column; align-items: center;
          padding-top: 4px;
        }
        .ab-tl-dot {
          width: 10px; height: 10px; border-radius: 50%;
          border: 2px solid var(--accent);
          box-shadow: 0 0 8px rgba(0,245,212,0.3);
          flex-shrink: 0;
        }
        .ab-tl-line {
          width: 1px; flex: 1; min-height: 14px;
          background: var(--border);
          margin-top: 4px;
        }
        .ab-tl-year {
          font-family: 'Space Mono', monospace;
          font-size: 0.62rem; letter-spacing: 0.1em;
          color: var(--accent); text-transform: uppercase;
          white-space: nowrap; margin-bottom: 2px;
        }
        .ab-tl-text {
          font-size: 0.85rem; color: var(--muted); line-height: 1.5;
        }
        .ab-tl-text strong { color: var(--text); }

        /* ── RIGHT — CARDS ── */
        .ab-right {
          opacity: 0;
          animation: abFadeUp 0.7s ease 0.35s forwards;
        }
        .ab-cards {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
        }

        .ab-card {
          background: var(--card-bg);
          border: 1px solid var(--border);
          border-radius: 12px;
          padding: 1.4rem 1.2rem;
          display: flex; flex-direction: column; gap: 10px;
          position: relative; overflow: hidden;
          transition: all 0.3s ease;
        }
        .ab-card::before {
          content: '';
          position: absolute; top: 0; left: 0; right: 0; height: 2px;
          background: linear-gradient(90deg, transparent, var(--accent), transparent);
          opacity: 0; transition: opacity 0.3s;
        }
        .ab-card:hover {
          border-color: rgba(0,245,212,0.25);
          background: rgba(0,245,212,0.04);
          transform: translateY(-3px);
        }
        .ab-card:hover::before { opacity: 1; }

        .ab-card-icon {
          width: 42px; height: 42px; border-radius: 10px;
          background: rgba(0,245,212,0.08);
          border: 1px solid rgba(0,245,212,0.15);
          display: flex; align-items: center; justify-content: center;
          color: var(--accent);
        }

        .ab-card-val {
          font-size: 1.4rem; font-weight: 800;
          color: var(--accent); line-height: 1;
        }
        .ab-card-title {
          font-size: 0.92rem; font-weight: 700; color: var(--text);
        }
        .ab-card-desc {
          font-family: 'Space Mono', monospace;
          font-size: 0.62rem; letter-spacing: 0.04em;
          color: var(--muted); line-height: 1.5;
        }

        /* wide card — skill bars */
        .ab-card-wide {
          grid-column: 1 / -1;
          flex-direction: row; align-items: flex-start;
          gap: 1.5rem;
        }
        .ab-card-wide .ab-card-icon {
          flex-shrink: 0;
          width: 50px; height: 50px; border-radius: 12px;
          background: rgba(123,97,255,0.1);
          border-color: rgba(123,97,255,0.2);
          color: var(--accent2);
        }
        .ab-card-wide .ab-card-val { color: var(--accent2); }
        .ab-card-wide-body { flex: 1; }

        .ab-skills { margin-top: 0.75rem; }
        .ab-skill { margin-bottom: 10px; }
        .ab-skill:last-child { margin-bottom: 0; }
        .ab-skill-row {
          display: flex; justify-content: space-between;
          align-items: baseline; margin-bottom: 4px;
        }
        .ab-skill-name {
          font-family: 'Space Mono', monospace;
          font-size: 0.62rem; letter-spacing: 0.08em;
          text-transform: uppercase; color: var(--muted);
        }
        .ab-skill-pct {
          font-family: 'Space Mono', monospace;
          font-size: 0.62rem; color: var(--accent);
        }
        .ab-bar {
          height: 3px; background: rgba(255,255,255,0.07);
          border-radius: 2px; overflow: hidden;
        }
        .ab-bar-fill {
          height: 100%; border-radius: 2px;
          background: linear-gradient(90deg, var(--accent), var(--accent2));
          animation: abBarGrow 0.9s ease forwards;
        }

        /* ── ANIMATIONS ── */
        @keyframes abFadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes abGrad {
          0%   { background-position: 0% center; }
          100% { background-position: 200% center; }
        }
        @keyframes abBarGrow {
          from { width: 0 !important; }
        }

        /* ── RESPONSIVE ── */
        @media (max-width: 900px) {
          .ab-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 480px) {
          .ab-cards { grid-template-columns: 1fr; }
          .ab-card-wide { flex-direction: column; }
        }
      `}</style>

      <section id="about" className="ab-section">
        <div className="ab-inner">

          {/* Heading */}
          <div className="ab-heading">
            <div className="ab-tag">Who I am</div>
            <h2 className="ab-main-title">
              About <span className="ab-accent">Me</span>
            </h2>
          </div>

          <div className="ab-grid">

            {/* ── LEFT — Bio + Timeline ── */}
            <div className="ab-left">
              <p className="ab-role">Full Stack Developer · MERN Specialist</p>

              <p className="ab-text">
                Self-taught developer who made a <strong>bold career pivot</strong> from
                administrative operations to full-stack engineering — entirely through
                dedicated self-learning and hands-on building.
              </p>
              <p className="ab-text">
                I specialize in <strong>React.js, Node.js, Express.js</strong> and MongoDB.
                I leverage AI tools for efficient problem-solving and continuously upgrade
                my skills with the latest technologies.
              </p>
              <p className="ab-text">
                With <strong>1 year of remote work</strong> experience at Essbee Fire
                Service, I've proven strong self-discipline, time management, and
                independent working capabilities.
              </p>

              {/* Timeline */}
              <div className="ab-timeline">
                {TIMELINE.map((item, i) => (
                  <div key={i} className="ab-tl-item">
                    <div className="ab-tl-dot-wrap">
                      <div className="ab-tl-dot" />
                      {i < TIMELINE.length - 1 && <div className="ab-tl-line" />}
                    </div>
                    <div>
                      <div className="ab-tl-year">{item.year}</div>
                      <div className="ab-tl-text"
                        dangerouslySetInnerHTML={{
                          __html: item.text.replace(/^([^—]+)/, '<strong>$1</strong>')
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ── RIGHT — Cards ── */}
            <div className="ab-right">
              <div className="ab-cards">

                {/* Card 1 */}
                <div className="ab-card">
                  <div className="ab-card-icon"><IconCode /></div>
                  <div className="ab-card-val">MERN</div>
                  <div className="ab-card-title">Stack Expert</div>
                  <div className="ab-card-desc">Mongo · Express · React · Node</div>
                </div>

                {/* Card 2 */}
                <div className="ab-card">
                  <div className="ab-card-icon"><IconProjects /></div>
                  <div className="ab-card-val">10+</div>
                  <div className="ab-card-title">Projects Built</div>
                  <div className="ab-card-desc">Full-stack applications shipped</div>
                </div>

                {/* Card 3 */}
                <div className="ab-card">
                  <div className="ab-card-icon"><IconEdu /></div>
                  <div className="ab-card-val">B.Tech</div>
                  <div className="ab-card-title">IT Graduate</div>
                  <div className="ab-card-desc">Asansol Engineering, 2017</div>
                </div>

                {/* Card 4 */}
                <div className="ab-card">
                  <div className="ab-card-icon"><IconRemote /></div>
                  <div className="ab-card-val">1 yr</div>
                  <div className="ab-card-title">Remote Work</div>
                  <div className="ab-card-desc">Proven async experience</div>
                </div>

                {/* Wide card — skill bars */}
                <div className="ab-card ab-card-wide">
                  <div className="ab-card-icon"><IconSkills /></div>
                  <div className="ab-card-wide-body">
                    <div className="ab-card-title" style={{ marginBottom: '0.75rem' }}>
                      Core Skills
                    </div>
                    <div className="ab-skills">
                      {SKILLS.map((skill) => (
                        <div key={skill.name} className="ab-skill">
                          <div className="ab-skill-row">
                            <span className="ab-skill-name">{skill.name}</span>
                            <span className="ab-skill-pct">{skill.pct}%</span>
                          </div>
                          <div className="ab-bar">
                            <div
                              className="ab-bar-fill"
                              style={{ width: `${skill.pct}%` }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default About;